/* eslint-disable camelcase */
import { type Dayjs } from "dayjs";
import type {
  Basket,
  BasketIdentifier,
  HistoricalOrderChannel,
  HistoricalOrderStatusFilter,
  OrderItem,
  SellerIdentifier,
  SellerType,
} from "@efood-commerce-sdk/typescript-axios-transaction-efood";
import type { BaseProduct } from "./Product";

export interface Validation {
  message: string;
  type: string;
}

export interface Approval {
  basketIdentifier: BasketIdentifier;
  approvalMessage: string;
  approvalStatus: "Approved" | "Info" | "Warning" | "Denial";
}

export interface ShipInfos {
  address1: string;
  address2: string;
  address3: string;
  city: string;
  email: string;
  firstname: string;
  lastname: string;
  zipcode: string;
}

export interface SubBaskets {
  [index: string]: SubBasket;
}

export interface SubBasket {
  articleType: string;
  orderitems: OrderItem[];
  total: number;
  totalProduct: number;
  totalAdjustment: number;
  totalShipping: number;
}

export interface DeliveryDate {
  date: Dayjs;
  validUntil?: Dayjs;
}

export const isOrderItem = (
  item?: OrderItem | BaseProduct
): item is OrderItem =>
  item != null && "orderitemId" in item && "article" in item;

export interface OrderHistoryQueryParams {
  organizationId?: string;
  storeId?: string;
  channel?: HistoricalOrderChannel;
  seller?: string[];
  orderStatus?: HistoricalOrderStatusFilter[];
  dateFrom?: string;
  dateTo?: string;
  page?: number;
  pageSize?: number;
}

export interface OrderHistory {
  entries: OrderHistoryDetails[];
  size: number;
}

export interface OrderHistoryDetails {
  orderType: number;
  notepadId: string;
  orderAmount: number;
  orderHistoryId: number;
  orderNumber: string;
  orderer: string;
  positions: number;
  deliveryDate: string;
  orderDate: string;
  orderState: number;
}

export interface BasketPrediction {
  type: string;
  customerNumber: string;
  cluster: {
    [index: string]: number;
  };
  individual: {
    [index: string]: number;
  };
}

export interface PromotionCode {
  id: string;
  code: string;
  active: boolean;
  qualified: boolean;
  conditions: string | null;
  name: string;
}

// Adds displayName and images to the SellerIdentifier which are added by selector
export interface ExtendedSellerIdentifier extends SellerIdentifier {
  displayName?: string;
  image1?: string;
  image2?: string;
}
export interface ExtendedBasketIdentifier extends BasketIdentifier {
  sellerIdentifier?: ExtendedSellerIdentifier;
}
export interface BasketWithExtendedSellerIdentifier extends Basket {
  identifier: ExtendedBasketIdentifier;
}

export interface SellerGroupWithBaskets {
  identifier: string;
  sellerType: SellerType;
  displayName?: string;
  image1?: string;
  image2?: string;
  total: number;
  totalProduct: number;
  totalAdjustment: number;
  totalShipping: number;
  baskets: Basket[];
}
